import createAxiosInstance from "../axios/axiosCustom"

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result.split(',')[1]) // Get Base64 part
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

export default async function uploadFile(file) {
  try {
    if(!file)  return 
    
    // const formData = new FormData()

    // formData.append('mimetype', file.type)
    // formData.append('originalName', file.name)
    // const base64File = await fileToBase64(file)
    // const image = {
    //   mimetype: file.type,
    //   originalName: file.name,
    //   image: base64File
    // }

    const axiosCustom = await createAxiosInstance()
    let res = await axiosCustom.post('/file/photo', file, {headers: { 'Content-Type': 'application/json' }})
    
    if(res) return res
    
  } catch (err) {
    console.log(err)
  }
}

export async function setBase64File(file) {
  const base64File = await fileToBase64(file)
  return {
    mimetype: file.type,
    originalName: file.name,
    image: base64File
  }
}
